import { render, staticRenderFns } from "./AttentionZones.vue?vue&type=template&id=3115ca18&scoped=true&"
import script from "./AttentionZones.vue?vue&type=script&lang=js&"
export * from "./AttentionZones.vue?vue&type=script&lang=js&"
import style0 from "./AttentionZones.vue?vue&type=style&index=0&id=3115ca18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3115ca18",
  null
  
)

export default component.exports